import { useRef, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useUser } from '../store/userState'
import { FaUserCircle } from 'react-icons/fa'
import { LuLogOut } from 'react-icons/lu'
import macawAvatar from '../assets/avatars/macaw.png'
import nexus from '../assets/nexusLogo.png'

const FloatBar = () => {
  const [overlayIsOpen, setOverlayIsOpen] = useState(false)
  const { user } = useUser()
  const overlayRef = useRef(null)
  const toggleButtonRef = useRef(null)
  const navigate = useNavigate()

  const toggleUserOverlay = () => {
    setOverlayIsOpen((prev) => !prev)
  }

  const handleClickOutside = (event) => {
    if (
      overlayRef.current &&
      !overlayRef.current.contains(event.target) &&
      toggleButtonRef.current &&
      !toggleButtonRef.current.contains(event.target)
    ) {
      setOverlayIsOpen(false)
    }
  }

  const handleLogout = () => {
    const confirmLogout = window.confirm('Are you sure you want to log out?')
    if (confirmLogout) {
      localStorage.removeItem('jwt')
      localStorage.removeItem('id')
      navigate('/login')
    }
  }

  useEffect(() => {
    if (overlayIsOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [overlayIsOpen])

  return (
    <header className="sticky top-0 z-40 flex h-[4.5rem] w-full items-center justify-between gap-3 border-b border-rule bg-surface/95 px-4 backdrop-blur-md sm:px-6">
      <Link to="/home" className="flex items-center gap-3 focus-visible:rounded-md">
        <div className="flex items-center gap-2">
          <div className="h-9 w-36 sm:h-10 sm:w-40">
            <img src={nexus} className="h-full w-full object-contain object-left" alt="Nexus V2" />
          </div>
          <span className="rounded-md border border-signal/40 bg-signal/10 px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-wider text-signal">
            V2
          </span>
        </div>
        <span className="hidden border-l border-rule pl-3 font-mono text-[10px] uppercase tracking-[0.2em] text-muted lg:inline">
          Operations
        </span>
      </Link>

      <div className="relative flex items-center gap-3">
        <div className="hidden text-right sm:block">
          <p className="text-sm font-semibold text-paper">
            {user?.firstName ? `Welcome, ${user.firstName}` : 'Welcome'}
          </p>
          <p className="font-mono text-[11px] uppercase tracking-wide text-muted">
            {user?.role || 'User'}
          </p>
        </div>
        <button
          type="button"
          ref={toggleButtonRef}
          onClick={toggleUserOverlay}
          className="rounded-full border-2 border-signal/70 p-0.5 transition hover:border-signal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal"
          aria-expanded={overlayIsOpen}
          aria-haspopup="menu"
          aria-label="Open account menu"
        >
          <img
            src={macawAvatar}
            alt=""
            className="h-10 w-10 rounded-full object-cover"
          />
        </button>

        {overlayIsOpen && (
          <div
            ref={overlayRef}
            role="menu"
            className="absolute right-0 top-[3.25rem] z-50 w-64 rounded-xl border border-rule bg-raised p-3 shadow-panel"
          >
            <p className="flex items-center gap-2 text-sm font-semibold text-paper">
              <span className="h-2 w-2 rounded-full bg-success" aria-hidden />
              {user?.firstName} {user?.lastName}
            </p>
            <p className="mb-3 truncate text-xs text-muted">{user?.email}</p>
            <Link
              to="/profile-settings"
              role="menuitem"
              className="nx-btn-ghost w-full justify-start"
              onClick={() => setOverlayIsOpen(false)}
            >
              <FaUserCircle className="h-4 w-4" />
              My profile
            </Link>
            <button type="button" role="menuitem" onClick={handleLogout} className="nx-btn-ghost w-full justify-start text-amber">
              <LuLogOut className="h-4 w-4" />
              Log out
            </button>
          </div>
        )}
      </div>
    </header>
  )
}

export default FloatBar
